import React from 'react';
import { Lock, ShieldCheck } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'urgency';
  className?: string;
  showTrust?: boolean;
}
export function CTAButton({
  text,
  href,
  onClick,
  variant = 'primary',
  className = '',
  showTrust = true
}: CTAButtonProps) {
  const baseClasses = 'relative w-full flex flex-col items-center justify-center min-h-[64px] px-6 py-4 rounded-xl font-bold text-lg md:text-xl transition-all duration-300 overflow-hidden group';
  const primaryClasses = 'bg-forest text-gold shadow-forest hover:bg-forest-light hover:-translate-y-1 animate-pulse-soft';
  const urgencyClasses = 'bg-urgency text-white shadow-lg hover:bg-urgency-light hover:-translate-y-1 animate-pulse-urgency';
  const buttonClasses = `${baseClasses} ${variant === 'primary' ? primaryClasses : urgencyClasses} ${className}`;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (href && href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) {
      onClick();
    }
  };
  const content = <>
      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12" data-id="element-18"></div>

      <span className="relative z-10 flex items-center text-center leading-tight text-[#FBFBFA]" data-id="element-19">
        {text}
      </span>
    </>;
  return <div className="w-full flex flex-col items-center" data-id="element-20">
      {href ? <a href={href} onClick={handleClick} className={buttonClasses} data-id="element-21">
          {content}
        </a> : <button onClick={handleClick} className={buttonClasses} data-id="element-22">
          {content}
        </button>}

      {showTrust && <div className="flex items-center justify-center gap-4 mt-3 text-xs md:text-sm text-dark/70 font-medium" data-id="element-23">
          <div className="flex items-center gap-1" data-id="element-24">
            <Lock size={14} className="text-forest" data-id="element-25" />
            <span data-id="element-26">Pago 100% Seguro</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-27">
            <ShieldCheck size={14} className="text-forest" data-id="element-28" />
            <span data-id="element-29">Garantía 30 Días</span>
          </div>
        </div>}
    </div>;
}